import * as actions from "modules/actions";
import type {LiveScoreSection} from "modules/sagas/live_score";
import React from "react";
import {connect} from "react-redux";

interface ILiveScore {
	subscribed_to_live_scores: boolean;
}

interface IOwnProps {
	section: LiveScoreSection;
	children: React.ReactNode;
}

const mapDispatchToProps = {
	unsubscribeFromLiveScores: actions.unsubscribeFromLiveScores,
	subscribeToLiveScores: actions.subscribeToLiveScores,
};

type TProps = typeof mapDispatchToProps & IOwnProps;
type TState = ILiveScore;

/**
 * Live score subscriber
 */
class HOCLiveScoreComponent extends React.Component<TProps, TState> {
	public state = {
		subscribed_to_live_scores: false,
	};

	public componentDidMount(): void {
		this.subscribeToLiveScore();
		window.addEventListener("online", () => this.subscribeToLiveScore());
		window.addEventListener("offline", () => this.unsubscribeFromLiveScoring());
	}

	/**
	 * @ignore
	 */
	public componentWillUnmount() {
		this.unsubscribeFromLiveScoring();
	}

	/**
	 * @ignore
	 */
	public render() {
		return <>{this.props.children}</>;
	}

	private subscribeToLiveScore() {
		const {subscribeToLiveScores: subscribe} = this.props;
		const {subscribed_to_live_scores} = this.state;

		if (!subscribed_to_live_scores) {
			this.setState({subscribed_to_live_scores: true}, () =>
				subscribe({
					section: this.props.section,
				})
			);
		}

		return true;
	}

	private unsubscribeFromLiveScoring() {
		const {unsubscribeFromLiveScores: unsubscirbe} = this.props;
		unsubscirbe();
		this.setState({
			subscribed_to_live_scores: false,
		});

		return this;
	}
}

export const HOCLiveScore = connect(null, mapDispatchToProps)(HOCLiveScoreComponent);
